import React from 'react';
import Sidebar from '../sidebar/Sidebar';
import { Outlet } from 'react-router-dom';
import TopNavMobile from '../TopNavMobile/TopNavMobile';
import ChatButton from '@components/ChatButton/ChatButton';
import { useOktaAuth } from "@okta/okta-react";
import ScrollToTop from '@/components/ScrollToTop/ScrollToTop';
import CanvasCacheBanner from "@/components/CanvasCacheBanner/CanvasCacheBanner";

const MainLayout: React.FC = () => {
    const showSwitchButton = true;
    const type = 'multi-student-lc';

    const { authState } = useOktaAuth();
    const accountId = authState?.isAuthenticated ? authState.accessToken?.claims?.accountId || '' : '';
    const identityId = authState?.isAuthenticated ? authState.idToken?.claims?.identityId || '' : '';
    const sub = authState?.isAuthenticated ? authState.accessToken?.claims?.sub || '' : '';

    return (
        <div className="main-layout">
            <ScrollToTop />  
            <div className="layout-body">
                <TopNavMobile type = {type} showSwitchButton={showSwitchButton} />
                <div className="sidebar-wrapper">
                    <Sidebar />
                </div>
                <main className="main-content">
					<div className="d-none" id="User_Identity_ID">{String(identityId)}</div>
                    <div className="d-none" id="User_Account_ID">{String(accountId)}</div>
                    <div className="d-none" id="User_Sub">{sub}</div>
                    <ChatButton identityId={String(identityId)} />
                    <CanvasCacheBanner 
                        message= {
                            <>
                                Having trouble loading the K12 School (OLS)? Try <span>clearing your cache and cookies</span> in your browser settings.
                            </>
                        } 
                    />
                    <Outlet />
                </main>
            </div>
        </div>  
    );
};
export default MainLayout;